import { Component, Primary, Secondary, Central, Hanger } from './action-bar';

type ActionBar = typeof Component & {
  Primary: typeof Primary;
  Secondary: typeof Secondary;
  Central: typeof Central;
  Hanger: typeof Hanger;
};

const ActionBar: ActionBar = Component as any;

ActionBar.Primary = Primary;
ActionBar.Secondary = Secondary;
ActionBar.Central = Central;
ActionBar.Hanger = Hanger;

export { ActionBar };
